import { type CustomerQuote, EMPTY_ARRAY, type UseDisclosureWithContextReturn } from '@talos/kyoko';
import { useFeatureFlag } from '../../hooks';
import { FixQuotePriceDialogV1 } from './FixQuotePriceDialogV1';
import { FixQuotePriceDialogV2 } from './V2/FixQuotePriceDialogV2';

/** A wrapper for the V1 and V2 versions of the fixing dialog. Based on the feature flag, will render the correct one for you */
export const FixQuotePriceDialog = (props: UseDisclosureWithContextReturn<CustomerQuote[]>) => {
  const { enableApplyFixingDialogV2 } = useFeatureFlag();

  if (enableApplyFixingDialogV2) {
    return <FixQuotePriceDialogV2 {...props} />;
  }

  return <FixQuotePriceDialogV1 selectedCustomerQuotes={props.context ?? EMPTY_ARRAY} {...props} />;
};
